// ====================================================
// src/components/block/liveStreamManagement/enchainements/DamierEnchainement.tsx
//
// Le cadre est découpé en tuiles ; chaque tuile bascule du flux final au
// preview à un instant différent, déterminé par sa position (diagonale
// haut-gauche → bas-droit) — une seule mosaïque plutôt qu'un vrai damier
// aléatoire, pour un résultat identique à chaque prise. Pas de réglage pour
// l'instant (grille fixe).
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface DamierConfig {}

const GRID_X = 8;
const GRID_Y = 6;

class DamierEnchainementImpl extends Enchainement<DamierConfig> {
  readonly id = 'damier';
  readonly label = 'Damier';
  readonly icon = 'Grid3x3';
  readonly defaultConfig: DamierConfig = {};

  render(input: EnchainementRenderInput, _config: DamierConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;

    // Flux final fixe en fond, plein cadre.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    if (progress <= 0) return;

    const tileW = width / GRID_X;
    const tileH = height / GRID_Y;
    const maxThreshold = GRID_X + GRID_Y - 2;

    ctx.save();
    ctx.beginPath();
    let anyTile = false;
    for (let row = 0; row < GRID_Y; row++) {
      for (let col = 0; col < GRID_X; col++) {
        const threshold = (col + row) / maxThreshold;
        if (progress >= threshold) {
          ctx.rect(col * tileW, row * tileH, tileW, tileH);
          anyTile = true;
        }
      }
    }
    if (anyTile) {
      ctx.clip();
      ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    }
    ctx.restore();
  }

  renderControls(_props: EnchainementControlProps<DamierConfig>) {
    return null;
  }
}

export const damierEnchainement = new DamierEnchainementImpl();
